/* Chahal Agri Farms — Watch & Shop (homepage shoppable video) ───────
 * Click-to-load embeds (no eager iframes), URL parsing for YouTube +
 * Instagram, arrow scroll, and Ajax add-to-cart that opens the cart
 * drawer. No build step; ES5-ish to match chahal-reviews.js. */
(function () {
  'use strict';

  function parseYouTubeId(url) {
    var m =
      url.match(/[?&]v=([\w-]{11})/) ||
      url.match(/youtu\.be\/([\w-]{11})/) ||
      url.match(/\/shorts\/([\w-]{11})/) ||
      url.match(/\/embed\/([\w-]{11})/);
    return m ? m[1] : null;
  }

  function parseInstagram(url) {
    var m = url.match(/instagram\.com\/(reel|p|tv)\/([\w-]+)/);
    return m ? { type: m[1], id: m[2] } : null;
  }

  /* Returns { kind:'youtube'|'instagram', embed:url } or null. */
  function buildEmbed(url) {
    if (!url) return null;
    var yt = parseYouTubeId(url);
    if (yt) {
      return { kind: 'youtube', embed: 'https://www.youtube.com/embed/' + yt + '?autoplay=1&rel=0&mute=1' };
    }
    var ig = parseInstagram(url);
    if (ig) {
      return { kind: 'instagram', embed: 'https://www.instagram.com/' + ig.type + '/' + ig.id + '/embed' };
    }
    return null;
  }

  function setYouTubeThumbs(root) {
    var imgs = root.querySelectorAll('[data-caf-ws-yt-thumb]');
    Array.prototype.forEach.call(imgs, function (img) {
      var btn = img.closest('[data-caf-ws-video]');
      if (!btn) return;
      var url = btn.getAttribute('data-video-url') || '';
      var yt = parseYouTubeId(url);
      if (yt) {
        img.src = 'https://img.youtube.com/vi/' + yt + '/hqdefault.jpg';
      } else {
        /* No YouTube thumb available (e.g. Instagram with no custom image):
           show a neutral placeholder so the play button still reads. */
        img.closest('.caf-ws__card').classList.add('caf-ws__card--noimg');
      }
    });
  }

  function showDialog(section) {
    var dialog = section.querySelector('[data-caf-ws-lightbox]');
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function openLightbox(section, embed) {
    var frame = section.querySelector('[data-caf-ws-frame]');
    if (!frame) return;
    frame.innerHTML = '<iframe src="' + embed +
      '" allow="autoplay; encrypted-media; fullscreen" allowfullscreen ' +
      'frameborder="0" class="caf-ws__iframe"></iframe>';
    showDialog(section);
  }

  /* Self-hosted Shopify video: play an MP4 in a native <video> element. */
  function openVideoLightbox(section, mp4) {
    var frame = section.querySelector('[data-caf-ws-frame]');
    if (!frame) return;
    var v = document.createElement('video');
    v.className = 'caf-ws__video-el';
    v.setAttribute('controls', '');
    v.setAttribute('autoplay', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'metadata');
    /* Muted for now (per request); the controls let visitors unmute. */
    v.muted = true;
    v.setAttribute('muted', '');
    v.src = mp4;
    frame.innerHTML = '';
    frame.appendChild(v);
    showDialog(section);
    if (typeof v.play === 'function') { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  function closeLightbox(section) {
    var dialog = section.querySelector('[data-caf-ws-lightbox]');
    var frame = section.querySelector('[data-caf-ws-frame]');
    if (frame) frame.innerHTML = '';
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component, cart-drawer, #cart-drawer, .cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
      if (typeof drawer.show === 'function') { try { drawer.show(); return; } catch (e) {} }
      drawer.classList.add('active', 'is-open', 'open');
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  /* Horizon re-renders the cart drawer only when a 'cart:update' event fires
     carrying freshly rendered section HTML. The drawer's line items live in
     <cart-items-component data-section-id="…"> elements; we must ask
     /cart/add.js to render those sections, then dispatch the event the theme
     listens for. Mirrors assets/product-form.js. */
  function cartItemsSectionIds() {
    var ids = [];
    var nodes = document.querySelectorAll('cart-items-component[data-section-id]');
    Array.prototype.forEach.call(nodes, function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    });
    return ids;
  }

  function dispatchCartUpdate(cart, sections, variantId) {
    var evt;
    try {
      evt = new Event('cart:update', { bubbles: true });
    } catch (e) {
      evt = document.createEvent('Event');
      evt.initEvent('cart:update', true, false);
    }
    /* Match the shape Horizon's components read (event.detail.data.sections). */
    evt.detail = {
      resource: cart || undefined,
      sourceId: 'caf-ws',
      data: {
        source: 'caf-ws',
        itemCount: cart ? cart.item_count : undefined,
        variantId: variantId,
        sections: sections
      }
    };
    document.dispatchEvent(evt);
  }

  /* Prefer the per-card variant <select> when present, so the customer's
     chosen variant is added (not just the product's first variant). */
  function selectedVariantId(btn) {
    var card = btn.closest('.caf-ws__card');
    if (card) {
      var sel = card.querySelector('[data-caf-ws-variant]');
      if (sel && sel.value) return sel.value;
    }
    return btn.getAttribute('data-variant-id');
  }

  function addToCart(btn) {
    var id = selectedVariantId(btn);
    if (!id) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    var sectionIds = cartItemsSectionIds();
    var body = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        btn.textContent = 'Added ✓';
        /* Pull the updated cart for item_count, then notify the theme so the
           drawer re-renders its line items (and auto-opens if configured). */
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return null; })
          .then(function (cart) {
            dispatchCartUpdate(cart, res.body.sections, id);
            openCartDrawer();
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
          });
      })
      .catch(function () {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
      });
  }

  /* When a card's variant <select> changes, reflect the chosen variant in
     the displayed price and the Add-to-cart button (id + availability). */
  function wireVariantSelects(section) {
    var sels = section.querySelectorAll('[data-caf-ws-variant]');
    Array.prototype.forEach.call(sels, function (sel) {
      sel.addEventListener('change', function () {
        var card = sel.closest('.caf-ws__card');
        if (!card) return;
        var opt = sel.options[sel.selectedIndex];
        if (!opt) return;
        var priceEl = card.querySelector('[data-caf-ws-price]');
        var price = opt.getAttribute('data-price');
        if (priceEl && price) priceEl.textContent = price;
        var available = opt.getAttribute('data-available') === 'true';
        var atc = card.querySelector('[data-caf-ws-atc]');
        if (atc) {
          atc.setAttribute('data-variant-id', sel.value);
          atc.disabled = !available;
          atc.textContent = available ? 'Add to cart' : 'Sold out';
        }
      });
    });
  }

  function wireSection(section) {
    if (section.dataset.cafWsWired) return;
    section.dataset.cafWsWired = '1';

    setYouTubeThumbs(section);
    wireVariantSelects(section);

    var track = section.querySelector('.caf-ws__track');
    var prev = section.querySelector('.caf-ws__arrow--prev');
    var next = section.querySelector('.caf-ws__arrow--next');
    if (track && prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -Math.round(track.clientWidth * 0.8), behavior: 'smooth' });
    });
    if (track && next) next.addEventListener('click', function () {
      track.scrollBy({ left: Math.round(track.clientWidth * 0.8), behavior: 'smooth' });
    });

    section.addEventListener('click', function (e) {
      var videoBtn = e.target.closest('[data-caf-ws-video]');
      if (videoBtn && section.contains(videoBtn)) {
        var mp4 = videoBtn.getAttribute('data-video-mp4') || '';
        if (mp4) { openVideoLightbox(section, mp4); return; }
        var url = videoBtn.getAttribute('data-video-url') || '';
        var info = buildEmbed(url);
        if (!info) { if (url) window.open(url, '_blank', 'noopener'); return; }
        if (info.kind === 'instagram') {
          /* IG embeds are frequently blocked; if it fails to render the
             user still has the new-tab fallback via the caption link. */
          window.open(url, '_blank', 'noopener');
          return;
        }
        openLightbox(section, info.embed);
        return;
      }
      var atc = e.target.closest('[data-caf-ws-atc]');
      if (atc && section.contains(atc)) { addToCart(atc); return; }
      var close = e.target.closest('[data-caf-ws-close]');
      if (close && section.contains(close)) { closeLightbox(section); return; }
    });

    var dialog = section.querySelector('[data-caf-ws-lightbox]');
    if (dialog) {
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closeLightbox(section);
      });
      dialog.addEventListener('close', function () {
        var frame = section.querySelector('[data-caf-ws-frame]');
        if (frame) frame.innerHTML = '';
      });
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-caf-ws]'), wireSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme-editor re-render support */
  document.addEventListener('shopify:section:load', init);
})();
